/* eslint-disable vue/no-unused-vars */
<template>
  <div class="paymentLinks">
    <a-card :loading="dashLoading" style="margin-bottom:1rem" class="card">
      <div slot="title">
        <a-button
          @click="backButton()"
          type="primary"
          size="small"
          icon="left"
          shape="circle"
          class="back-button"
        />&nbsp; <a-icon type="link" style="margin-right:5px; font-size:22px" />
        <span class="main-card-title">Links de Pago</span>
      </div>
      <h3>
        <strong>Links Activos:</strong>
        {{ dash.activeLinks }}
      </h3>
      <!--
      <a-collapse :bordered="false">
        <a-collapse-panel header="MÁS DETALLES" key="1">
          
          <div :class="$style.optionTitle">Precio:</div>
          <div :class="$style.option">
            <a-input
              :defaultValue="this.subscription.amount"
              style="width:110px"
              size="small"
              ><span slot="prefix">$</span>
            </a-input>
          </div>

        </a-collapse-panel>
      </a-collapse>
      -->
      <router-link :to="{ name: 'paymentLinkAdd' }"
        ><a-button type="primary" size="small" style="padding-top:2px">
          <!--<a-icon type="like" style="margin-right:0.5em" />-->Crear Nuevo
        </a-button></router-link
      >
    </a-card>
    <a-card
      :headStyle="{ marginBottom: '0', paddingBottom: '0', minHeight: '40px' }"
      :bodyStyle="{ paddingTop: '3px' }"
      class="card"
    >
      <div v-if="showHeader" slot="title" :class="$style.listHeadTitle">
        <div :class="$style.searchWrapper">
          <a-input-search
            placeholder="Buscar..."
            enterButton
            @change="handleSearch"
          />
        </div>
      </div>
      <div v-if="showHeader" slot="extra" :class="$style.extraStyle">
        <a-dropdown
          placement="bottomCenter"
          style="margin-right:1rem"
          v-if="!orderBySelection.key"
        >
          <a class="ant-dropdown-link">
            <span :class="$style.orderByLabel">Ordenar por: </span>
            <a-icon type="down"
          /></a>
          <a-menu slot="overlay" @click="handleOrderByClick">
            <a-menu-item v-for="option in orderByOptions" :key="option.key">{{
              option.value
            }}</a-menu-item>
          </a-menu>
        </a-dropdown>

        <span
          v-else-if="orderBySelection.orderAsc"
          :class="$style.orderByLabel"
        >
          <a-tag @click="handleOrderAscClick" color="green"
            >Ordenado Por: {{ orderBySelection.value }}
            <a-icon type="sort-ascending" />
          </a-tag>
        </span>
        <span v-else :class="$style.orderByLabel">
          <a-tag closable @click="handleOrderByClose" color="orange"
            >Ordenado por: {{ orderBySelection.value }}
            <a-icon type="sort-descending" />
          </a-tag>
        </span>

        <a-dropdown
          placement="bottomCenter"
          style="margin-right:1rem"
          v-if="!statusFilterSelection.key"
        >
          <a class="ant-dropdown-link"> Estado: Activo<a-icon type="down"/></a>
          <a-menu slot="overlay" @click="handleStatusFilterClick">
            <a-menu-item
              v-for="option in statusFilterOptions"
              :key="option.key"
              >{{ option.value }}</a-menu-item
            >
          </a-menu>
        </a-dropdown>
        <span v-else :class="$style.orderByLabel">
          <a-tag closable @click="handleStatusFilterClose" color="orange"
            >Estado: {{ statusFilterSelection.value }}
          </a-tag>
        </span>
      </div>

      <div v-if="displayEmptyMessage" style="margin-top:2rem">
        <h5 style="color:#555;">No se registran links de pago.</h5>
      </div>
      <div
        :class="$style.demoInfiniteContainer"
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="scrollDisabled"
        :infinite-scroll-distance="15"
        infinite-scroll-event-target="window"
      >
        <a-list :dataSource="listData" size="small">
          <a-list-item slot="renderItem" slot-scope="item" key="item.id">
            <a-list-item-meta>
              <!--
              <a-avatar
                slot="avatar"
                style="backgroundColor:#b7eb8f; borderColor:#52c41a"
                icon="user"
              />
              -->

              <div slot="avatar" :class="$style.avatarDiv">
                <span v-if="item.statusId == 1">
                  <!--activo-->
                  <div :class="$style.avatarWithId">
                    <a-avatar :class="$style.green" icon="link" />
                  </div>
                  <span :class="[$style.idBox, $style.green]"
                    >#{{ item.id }}
                  </span>
                </span>
                <span v-else-if="item.statusId == 2"
                  ><!--inactivo-->
                  <div :class="$style.avatarWithId">
                    <a-avatar :class="$style.pink" icon="link" />
                  </div>
                  <span :class="[$style.idBox, $style.pink]"
                    >#{{ item.id }}
                  </span>
                </span>
                <span v-else-if="item.statusId == 3"
                  ><!--expirado-->
                  <div :class="$style.avatarWithId">
                    <a-avatar :class="$style.orange" icon="link" />
                  </div>
                  <span :class="[$style.idBox, $style.orange]"
                    >#{{ item.id }}
                  </span>
                </span>
              </div>

              <h4 slot="title">
                <router-link :key="'view'" :to="`/payment-links/${item.id}`">
                  {{ item.name }}
                </router-link>
                <span style="font-size:10px">&nbsp;</span>
              </h4>
              <div slot="description" :class="$style.grayText">
                <span v-if="item.description && item.description !== ''">
                  {{ item.description }}
                  <br />
                </span>

                <span v-if="item.amount">
                  Precio:
                  {{
                    new Intl.NumberFormat("es-AR", {
                      style: "currency",
                      currency: "ARS"
                    }).format(item.amount)
                  }} </span
                ><!--&nbsp;&nbsp;|&nbsp;&nbsp;<a
                  @click="handleLinkCopy(item.id)"
                  <a-icon
                  type="link"
                />
                {{ item.activeSubscribers }}</a>-->
              </div>
            </a-list-item-meta>

            <template slot="actions">
              <router-link :key="'edit'" :to="`/payment-links/${item.id}`"
                ><a-icon type="eye" /> Ver Detalle
              </router-link>
            </template>
          </a-list-item>

          <a-skeleton
            :loading="loadingData"
            :paragraph="{ rows: 1, width: '100%' }"
            active
            :title="false"
            style="margin-top:2rem"
          />
          <a-skeleton
            :loading="loadingData"
            :paragraph="{ rows: 1, width: '100%' }"
            active
            :title="false"
          />
          <a-skeleton
            :loading="loadingData"
            :paragraph="{ rows: 1, width: '100%' }"
            active
            :title="false"
          />
        </a-list>
      </div>
    </a-card>
  </div>
</template>
<script>
//import { data } from "./data.json";
import { mapActions } from "vuex";
import store from "@/store";
import infiniteScroll from "@/services/vue-infinite-scroll";
import utils from "@/services/utils";
//import { RecycleScroller } from "vue-virtual-scroller";

export default {
  name: "paymentLinksList", //necesita tener un name para que funcione el <keep-alive>
  directives: { infiniteScroll },
  props: {
    showHeader: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      pagination: {
        position: "bottom"
      },
      loadingData: false,
      dash: {
        activeLinks: null
      },
      dashLoading: false,
      scrollDisabled: false,
      displayEmptyMessage: false,
      listData: [],
      orderBySelection: { key: null, value: null },
      orderByOptions: [
        { key: "id", value: "Id" },
        { key: "name", value: "Nombre" },
        { key: "createdAt", value: "Fecha de Alta" }
      ],
      statusFilterSelection: { key: null, value: null },
      statusFilterOptions: [
        { key: "0", value: "Todos" },
        { key: "1", value: "Activo" },
        { key: "2", value: "Inactivo" },
        { key: "3", value: "Expirado" }
      ]
    };
  },
  methods: {
    ...mapActions({
      loadPaymentLinks: "paymentLinks/load",
      loadDash: "paymentLinks/loadDash"
    }),
    async fetchList() {
      try {
        this.displayEmptyMessage = false;
        //console.log("params:", params);
        if (!this.loadingData) {
          this.loadingData = true;
          const result = await this.loadPaymentLinks();
          if (store.state.paymentLinks.results.length > 0) {
            this.listData = this.listData.concat(
              store.state.paymentLinks.results
            );
          }
          //add results to existing results
          else this.displayEmptyMessage = true;

          this.loadingData = false;
        }
      } catch (error) {
        this.loadingData = false;
        if (error.status == 404) {
          this.displayEmptyMessage = true;
        } else {
          this.$notification["warning"]({
            message: error.code,
            description: error.statusCode
          });
        }
      }
    },
    async fetchDashboardData() {
      try {
        //console.log("params:", params);

        this.dashLoading = true;
        const result = await this.loadDash();
        this.dash = store.state.paymentLinks.dash;
        this.dashLoading = false;
      } catch (error) {
        this.dashLoading = false;
        this.$notification["warning"]({
          message: error.code,
          description: error.message
        });
      }
    },
    async loadMore() {
      try {
        if (
          //todavia hay registros para bajar
          this.$store.state.paymentLinks.totalResults >
          this.$store.state.paymentLinks.page *
            this.$store.state.paymentLinks.pageSize
        ) {
          this.scrollDisabled = true;
          this.$nprogress.start();
          const result = await this.fetchList();
          this.scrollDisabled = false;
          this.$nprogress.done();
        }
        return;
      } catch (error) {
        this.scrollDisabled = false;
        this.$nprogress.done();
        this.$notification["failure"]({
          message: "Error",
          description: `Hubo un error al cargar el listado. Disabled: ${this.scrollDisabled}`
        });
      }
    },
    handleOrderByClick(event) {
      const orderByOption = this.orderByOptions.find(opt => {
        return opt.key == event.key;
      });
      this.orderBySelection = orderByOption;
      this.orderBySelection.orderAsc = true;
      this.$store.commit("paymentLinks/SET_ORDER_BY", event.key);
      this.$store.commit("paymentLinks/SET_ORDER_ASC", true);
      this.$store.commit("paymentLinks/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      this.fetchList(true);
    },
    handleOrderAscClick() {
      this.orderBySelection.orderAsc = false;
      this.$store.commit(
        "paymentLinks/SET_ORDER_BY",
        this.orderBySelection.key
      );
      this.$store.commit("paymentLinks/SET_ORDER_ASC", false); //desc
      this.$store.commit("paymentLinks/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      this.fetchList(true);
    },
    handleOrderByClose() {
      this.orderBySelection = { key: null, value: null };
      this.$store.commit("paymentLinks/SET_ORDER_BY", null);
      this.$store.commit("paymentLinks/SET_ORDER_ASC", null);
      this.$store.commit("paymentLinks/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      this.fetchList(true);
    },
    handleStatusFilterClick(event) {
      const statusFilterOption = this.statusFilterOptions.find(opt => {
        return opt.key == event.key;
      });
      this.statusFilterSelection = statusFilterOption;
      this.$store.commit("paymentLinks/SET_STATUS_ID", event.key);
      this.$store.commit("paymentLinks/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      //this.loadMore();
      this.fetchList(true);
    },
    handleStatusFilterClose() {
      this.statusFilterSelection = { key: null, value: null };
      this.$store.commit("paymentLinks/SET_STATUS_ID", null);
      this.$store.commit("paymentLinks/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      this.fetchList(true);
    },
    handleSearch(keyword) {
      this.$store.commit("paymentLinks/SET_SEARCH", keyword.target.value);
      this.$store.commit("paymentLinks/SET_RESET_PAGE");
      this.listData = [];
      this.scrollDisabled = false;
      this.fetchList(true);
    },
    handleEmailCopy(email) {
      utils.copyToClipboard(email);
      this.$notification["success"]({
        message: "Link copiado.",
        description:
          "Para pegarlo tipea ctrl + v en el teclado o elije la opción 'Pegar' con el botón derecho del mouse."
      });
    }
  },
  created() {
    //window.addEventListener("touchmove", this.loadMore);
  },
  mounted() {
    this.$store.commit("paymentLinks/SET_RESET_PAGE");
    this.fetchList();
    this.fetchDashboardData();
  },
  activated() {
    //it's run when actived in keep-alive mode
    if (this.$store.state.paymentLinks.listUpdated) {
      this.listData = [];
      this.$store.commit("paymentLinks/SET_RESET_PAGE");
      this.$store.commit("paymentLinks/SET_LIST_UPDATED", false);
      this.fetchList();
      this.fetchDashboardData();
    }
  }
};
</script>

<style lang="scss" module>
@import "./index.module.scss";
.editable-row-operations a {
  margin-right: 8px;
}
</style>

<style lang="css">
.demo-loading-container {
  position: absolute;
  bottom: 50%;
  width: 100%;
  text-align: center;
}
.ant-list-item-action {
  margin-top: 1rem;
}
.ant-dropdown-link {
  text-transform: none;
  font-weight: normal;
}
.ant-card-head {
  min-height: 44px;
}
.ant-card-head-wrapper {
  flex-direction: row;
}
.ant-card-extra,
.ant-card-head-title {
  padding-top: 13px;
  padding-bottom: 9px;
}
.ant-card-body {
  padding: 17px 32px;
}
.ant-tag {
  vertical-align: middle;
}
.back-button {
  vertical-align: 0.38rem;
}
strong {
  color: #000;
  font-weight: 700;
}
h4:hover {
  color: #0190fe;
  cursor: pointer;
}
.anticon {
  vertical-align: -0.2rem;
}
.ant-tag {
  vertical-align: 0.2rem;
}
</style>
